const _changeEvent$1 = { type: 'change' };

class FlyControls extends THREE.EventDispatcher {

	constructor( object, domElement ) {

		super();

		if ( domElement === undefined ) {

			console.warn( 'THREE.FlyControls: The second parameter "domElement" is now mandatory.' );
			domElement = document;

		}

		this.object = object;
		this.domElement = domElement;

		// API

		this.movementSpeed = 1.0;
		this.rollSpeed = 0.005;

		this.dragToLook = false;
		this.autoForward = false;

		// disable default target object behavior

		// internals

		const scope = this;

		const EPS = 0.000001;

		const lastQuaternion = new THREE.Quaternion();
		const lastPosition = new THREE.Vector3();

		this.tmpQuaternion = new THREE.Quaternion();

		this.mouseStatus = 0;

		this.moveState = { up: 0, down: 0, left: 0, right: 0, forward: 0, back: 0, pitchUp: 0, pitchDown: 0, yawLeft: 0, yawRight: 0, rollLeft: 0, rollRight: 0 };
		this.moveVector = new THREE.Vector3( 0, 0, 0 );
		this.rotationVector = new THREE.Vector3( 0, 0, 0 );

		this.keydown = function ( event ) {

			if ( event.altKey ) {

				return;

			}

			switch ( event.code ) {

				case 'ShiftLeft':
				case 'ShiftRight': this.movementSpeedMultiplier = .1; break;

				case 'KeyW': this.moveState.forward = 1; break;
				case 'KeyS': this.moveState.back = 1; break;

				case 'KeyA': this.moveState.left = 1; break;
				case 'KeyD': this.moveState.right = 1; break;

				case 'KeyR': this.moveState.up = 1; break;
				case 'KeyF': this.moveState.down = 1; break;

				case 'ArrowUp': this.moveState.pitchUp = 1; break;
				case 'ArrowDown': this.moveState.pitchDown = 1; break;

				case 'ArrowLeft': this.moveState.yawLeft = 1; break;
				case 'ArrowRight': this.moveState.yawRight = 1; break;

				case 'KeyQ': this.moveState.rollLeft = 1; break;
				case 'KeyE': this.moveState.rollRight = 1; break;

			}

			this.updateMovementVector();
			this.updateRotationVector();

		};

		this.keyup = function ( event ) {

			switch ( event.code ) {

				case 'ShiftLeft':
				case 'ShiftRight': this.movementSpeedMultiplier = 1; break;

				case 'KeyW': this.moveState.forward = 0; break;
				case 'KeyS': this.moveState.back = 0; break;

				case 'KeyA': this.moveState.left = 0; break;
				case 'KeyD': this.moveState.right = 0; break;

				case 'KeyR': this.moveState.up = 0; break;
				case 'KeyF': this.moveState.down = 0; break;

				case 'ArrowUp': this.moveState.pitchUp = 0; break;
				case 'ArrowDown': this.moveState.pitchDown = 0; break;

				case 'ArrowLeft': this.moveState.yawLeft = 0; break;
				case 'ArrowRight': this.moveState.yawRight = 0; break;

				case 'KeyQ': this.moveState.rollLeft = 0; break;
				case 'KeyE': this.moveState.rollRight = 0; break;

			}

			this.updateMovementVector();
			this.updateRotationVector();

		};

		this.mousedown = function ( event ) {

			if ( this.dragToLook ) {

				this.mouseStatus ++;

			} else {

				switch ( event.button ) {

					case 0: this.moveState.forward = 1; break;
					case 2: this.moveState.back = 1; break;

				}

				this.updateMovementVector();

			}

		};

		this.mousemove = function ( event ) {

			if ( ! this.dragToLook || this.mouseStatus > 0 ) {

				const container = this.getContainerDimensions();
				const halfWidth = container.size[ 0 ] / 2;
				const halfHeight = container.size[ 1 ] / 2;

				this.moveState.yawLeft = - ( ( event.pageX - container.offset[ 0 ] ) - halfWidth ) / halfWidth;
				this.moveState.pitchDown = ( ( event.pageY - container.offset[ 1 ] ) - halfHeight ) / halfHeight;

				this.updateRotationVector();

			}

		};

		this.mouseup = function ( event ) {

			if ( this.dragToLook ) {

				this.mouseStatus --;

				this.moveState.yawLeft = this.moveState.pitchDown = 0;

			} else {

				switch ( event.button ) {

					case 0: this.moveState.forward = 0; break;
					case 2: this.moveState.back = 0; break;

				}

				this.updateMovementVector();

			}

			this.updateRotationVector();

		};

		this.update = function ( delta ) {

			const moveMult = delta * scope.movementSpeed;
			const rotMult = delta * scope.rollSpeed;

			scope.object.translateX( scope.moveVector.x * moveMult );
			scope.object.translateY( scope.moveVector.y * moveMult );
			scope.object.translateZ( scope.moveVector.z * moveMult );

			scope.tmpQuaternion.set( scope.rotationVector.x * rotMult, scope.rotationVector.y * rotMult, scope.rotationVector.z * rotMult, 1 ).normalize();
			scope.object.quaternion.multiply( scope.tmpQuaternion );

			if (
				lastPosition.distanceToSquared( scope.object.position ) > EPS ||
				8 * ( 1 - lastQuaternion.dot( scope.object.quaternion ) ) > EPS
			) {

				scope.dispatchEvent( _changeEvent$1 );
				lastQuaternion.copy( scope.object.quaternion );
				lastPosition.copy( scope.object.position );

			}

		};

		this.updateMovementVector = function () {

			const forward = ( this.moveState.forward || ( this.autoForward && ! this.moveState.back ) ) ? 1 : 0;

			this.moveVector.x = ( - this.moveState.left + this.moveState.right );
			this.moveVector.y = ( - this.moveState.down + this.moveState.up );
			this.moveVector.z = ( - forward + this.moveState.back );

			//console.log( 'move:', [ this.moveVector.x, this.moveVector.y, this.moveVector.z ] );

		};

		this.updateRotationVector = function () {

			this.rotationVector.x = ( - this.moveState.pitchDown + this.moveState.pitchUp );
			this.rotationVector.y = ( - this.moveState.yawRight + this.moveState.yawLeft );
			this.rotationVector.z = ( - this.moveState.rollRight + this.moveState.rollLeft );

			//console.log( 'rotate:', [ this.rotationVector.x, this.rotationVector.y, this.rotationVector.z ] );

		};

		this.getContainerDimensions = function () {

			if ( this.domElement != document ) {

				return {
					size: [ this.domElement.offsetWidth, this.domElement.offsetHeight ],
					offset: [ this.domElement.offsetLeft, this.domElement.offsetTop ]
				};

			} else {

				return {
					size: [ window.innerWidth, window.innerHeight ],
					offset: [ 0, 0 ]
				};

			}

		};

		this.dispose = function () {

			this.domElement.removeEventListener( 'contextmenu', contextmenu$1 );
			this.domElement.removeEventListener( 'mousedown', _mousedown );
			this.domElement.removeEventListener( 'mousemove', _mousemove );
			this.domElement.removeEventListener( 'mouseup', _mouseup );

			window.removeEventListener( 'keydown', _keydown );
			window.removeEventListener( 'keyup', _keyup );

		};

		const _mousemove = this.mousemove.bind( this );
		const _mousedown = this.mousedown.bind( this );
		const _mouseup = this.mouseup.bind( this );
		const _keydown = this.keydown.bind( this );
		const _keyup = this.keyup.bind( this );

		this.domElement.addEventListener( 'contextmenu', contextmenu$1 );

		this.domElement.addEventListener( 'mousemove', _mousemove );
		this.domElement.addEventListener( 'mousedown', _mousedown );
		this.domElement.addEventListener( 'mouseup', _mouseup );

		window.addEventListener( 'keydown', _keydown );
		window.addEventListener( 'keyup', _keyup );

		this.updateMovementVector();
		this.updateRotationVector();

	}

}

function contextmenu$1( event ) {

	event.preventDefault();

}

const _lookDirection = new THREE.Vector3();
const _spherical = new THREE.Spherical();
const _target = new THREE.Vector3();

class FirstPersonControls {

	constructor( object, domElement ) {

		if ( domElement === undefined ) {

			console.warn( 'THREE.FirstPersonControls: The second parameter "domElement" is now mandatory.' );
			domElement = document;

		}

		this.object = object;
		this.domElement = domElement;

		// API

		this.enabled = true;

		this.movementSpeed = 1.0;
		this.lookSpeed = 0.005;

		this.lookVertical = true;
		this.autoForward = false;

		this.activeLook = true;

		this.heightSpeed = false;
		this.heightCoef = 1.0;
		this.heightMin = 0.0;
		this.heightMax = 1.0;

		this.constrainVertical = false;
		this.verticalMin = 0;
		this.verticalMax = Math.PI;

		this.mouseDragOn = false;

		// internals

		this.autoSpeedFactor = 0.0;

		this.mouseX = 0;
		this.mouseY = 0;

		this.moveForward = false;
		this.moveBackward = false;
		this.moveLeft = false;
		this.moveRight = false;

		this.viewHalfX = 0;
		this.viewHalfY = 0;

		// private variables

		let lat = 0;
		let lon = 0;

		//

		this.handleResize = function () {

			if ( this.domElement === document ) {

				this.viewHalfX = window.innerWidth / 2;
				this.viewHalfY = window.innerHeight / 2;

			} else {

				this.viewHalfX = this.domElement.offsetWidth / 2;
				this.viewHalfY = this.domElement.offsetHeight / 2;

			}

		};

		this.onMouseDown = function ( event ) {

			if ( this.domElement !== document ) {

				this.domElement.focus();

			}

			/*if ( this.activeLook ) {

				switch ( event.button ) {

					case 0: this.moveForward = true; break;
					case 2: this.moveBackward = true; break;

				}

			}*/

			this.mouseDragOn = true;

			this._x = event.clientX;
			this._y = event.clientY;
			this.domElement.addEventListener( 'mousemove', _onMouseMove );
		};

		this.onMouseUp = function ( event ) {

			/*if ( this.activeLook ) {

				switch ( event.button ) {

					case 0: this.moveForward = false; break;
					case 2: this.moveBackward = false; break;

				}

			}*/

			this.mouseDragOn = false;
			this.mouseX = 0;
			this.mouseY = 0;
			this.domElement.removeEventListener( 'mousemove', _onMouseMove );
		};

		this.onMouseMove = function ( event ) {

			this.mouseX = event.clientX - this._x;
			this.mouseY = event.clientY - this._y;

			this._x = event.clientX;
			this._y = event.clientY;
		};

		this.onKeyDown = function ( event ) {

			switch ( event.code ) {

				case 'ArrowUp':
				case 'KeyW': this.moveForward = true; break;

				case 'ArrowLeft':
				case 'KeyA': this.moveLeft = true; break;

				case 'ArrowDown':
				case 'KeyS': this.moveBackward = true; break;

				case 'ArrowRight':
				case 'KeyD': this.moveRight = true; break;

				case 'KeyR': this.moveUp = true; break;
				case 'KeyF': this.moveDown = true; break;

			}

		};

		this.onKeyUp = function ( event ) {

			switch ( event.code ) {

				case 'ArrowUp':
				case 'KeyW': this.moveForward = false; break;

				case 'ArrowLeft':
				case 'KeyA': this.moveLeft = false; break;

				case 'ArrowDown':
				case 'KeyS': this.moveBackward = false; break;

				case 'ArrowRight':
				case 'KeyD': this.moveRight = false; break;

				case 'KeyR': this.moveUp = false; break;
				case 'KeyF': this.moveDown = false; break;

			}

		};

		this.lookAt = function ( x, y, z ) {

			if ( x.isVector3 ) {

				_target.copy( x );

			} else {

				_target.set( x, y, z );

			}

			this.object.lookAt( _target );

			setOrientation( this );

			return this;

		};

		this.update = function () {

			const targetPosition = new THREE.Vector3();

			return function update( delta ) {

				if ( this.enabled === false ) return;

				if ( this.heightSpeed ) {

					const y = THREE.MathUtils.clamp( this.object.position.y, this.heightMin, this.heightMax );
					const heightDelta = y - this.heightMin;

					this.autoSpeedFactor = delta * ( heightDelta * this.heightCoef );

				} else {

					this.autoSpeedFactor = 0.0;

				}

				const actualMoveSpeed = delta * this.movementSpeed;

				if ( this.moveForward || ( this.autoForward && ! this.moveBackward ) ) this.object.translateZ( - ( actualMoveSpeed + this.autoSpeedFactor ) );
				if ( this.moveBackward ) this.object.translateZ( actualMoveSpeed );

				if ( this.moveLeft ) this.object.translateX( - actualMoveSpeed );
				if ( this.moveRight ) this.object.translateX( actualMoveSpeed );

				if ( this.moveUp ) this.object.translateY( actualMoveSpeed );
				if ( this.moveDown ) this.object.translateY( - actualMoveSpeed );

				let actualLookSpeed = delta * this.lookSpeed;

				if ( ! this.activeLook ) {

					actualLookSpeed = 0;

				}

				let verticalLookRatio = 1;

				if ( this.constrainVertical ) {

					verticalLookRatio = Math.PI / ( this.verticalMax - this.verticalMin );

				}

				lon -= this.mouseX * actualLookSpeed;
				if ( this.lookVertical ) lat -= this.mouseY * actualLookSpeed * verticalLookRatio;

				lat = Math.max( - 85, Math.min( 85, lat ) );

				let phi = THREE.MathUtils.degToRad( 90 - lat );
				const theta = THREE.MathUtils.degToRad( lon );

				if ( this.constrainVertical ) {

					phi = THREE.MathUtils.mapLinear( phi, 0, Math.PI, this.verticalMin, this.verticalMax );

				}

				const position = this.object.position;

				targetPosition.setFromSphericalCoords( 1, phi, theta ).add( position );

				this.object.lookAt( targetPosition );

			};

		}();

		this.dispose = function () {

			this.domElement.removeEventListener( 'contextmenu', contextmenu );
			this.domElement.removeEventListener( 'mousedown', _onMouseDown );
			this.domElement.removeEventListener( 'mousemove', _onMouseMove );
			this.domElement.removeEventListener( 'mouseup', _onMouseUp );

			window.removeEventListener( 'keydown', _onKeyDown );
			window.removeEventListener( 'keyup', _onKeyUp );

		};

		const _onMouseMove = this.onMouseMove.bind( this );
		const _onMouseDown = this.onMouseDown.bind( this );
		const _onMouseUp = this.onMouseUp.bind( this );
		const _onKeyDown = this.onKeyDown.bind( this );
		const _onKeyUp = this.onKeyUp.bind( this );

		this.domElement.addEventListener( 'contextmenu', contextmenu );
		// this.domElement.addEventListener( 'mousemove', _onMouseMove );
		this.domElement.addEventListener( 'mousedown', _onMouseDown );
		this.domElement.addEventListener( 'mouseup', _onMouseUp );

		window.addEventListener( 'keydown', _onKeyDown );
		window.addEventListener( 'keyup', _onKeyUp );

		function setOrientation( controls ) {

			const quaternion = controls.object.quaternion;

			_lookDirection.set( 0, 0, - 1 ).applyQuaternion( quaternion );
			_spherical.setFromVector3( _lookDirection );

			lat = 90 - THREE.MathUtils.radToDeg( _spherical.phi );
			lon = THREE.MathUtils.radToDeg( _spherical.theta );

		}

		this.handleResize();

		setOrientation( this );

	}

}

function contextmenu( event ) {

	event.preventDefault();

}

// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move

const _changeEvent = { type: 'change' };
const _startEvent = { type: 'start' };
const _endEvent = { type: 'end' };

class OrbitControls extends THREE.EventDispatcher {

	constructor( object, domElement ) {

		super();

		if ( domElement === undefined ) console.warn( 'THREE.OrbitControls: The second parameter "domElement" is now mandatory.' );
		if ( domElement === document ) console.error( 'THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.' );

		this.object = object;
		this.domElement = domElement;

		// Set to false to disable this control
		this.enabled = true;

		// "target" sets the location of focus, where the object orbits around
		this.target = new THREE.Vector3();

		// How far you can dolly in and out ( PerspectiveCamera only )
		this.minDistance = 0;
		this.maxDistance = Infinity;

		// How far you can zoom in and out ( OrthographicCamera only )
		this.minZoom = 0;
		this.maxZoom = Infinity;

		// How far you can orbit vertically, upper and lower limits.
		// Range is 0 to Math.PI radians.
		this.minPolarAngle = 0; // radians
		this.maxPolarAngle = Math.PI; // radians

		// How far you can orbit horizontally, upper and lower limits.
		// If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
		this.minAzimuthAngle = - Infinity; // radians
		this.maxAzimuthAngle = Infinity; // radians

		// Set to true to enable damping (inertia)
		// If damping is enabled, you must call controls.update() in your animation loop
		this.enableDamping = false;
		this.dampingFactor = 0.05;

		// This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
		// Set to false to disable zooming
		this.enableZoom = true;
		this.zoomSpeed = 1.0;

		// Set to false to disable rotating
		this.enableRotate = true;
		this.rotateSpeed = 1.0;

		// Set to false to disable panning
		this.enablePan = true;
		this.panSpeed = 1.0;
		this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
		this.keyPanSpeed = 7.0;	// pixels moved per arrow key push

		// Set to true to automatically rotate around the target
		// If auto-rotate is enabled, you must call controls.update() in your animation loop
		this.autoRotate = false;
		this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60

		// The four arrow keys
		this.keys = { LEFT: 'ArrowLeft', UP: 'ArrowUp', RIGHT: 'ArrowRight', BOTTOM: 'ArrowDown' };

		// Mouse buttons
		this.mouseButtons = { LEFT: THREE.MOUSE.ROTATE, MIDDLE: THREE.MOUSE.DOLLY, RIGHT: THREE.MOUSE.PAN };

		// Touch fingers
		this.touches = { ONE: THREE.TOUCH.ROTATE, TWO: THREE.TOUCH.DOLLY_PAN };

		// for reset
		this.target0 = this.target.clone();
		this.position0 = this.object.position.clone();
		this.zoom0 = this.object.zoom;

		// the target DOM element for key events
		this._domElementKeyEvents = null;

		//
		// public methods
		//

		this.getPolarAngle = function () {

			return spherical.phi;

		};

		this.getAzimuthalAngle = function () {

			return spherical.theta;

		};

		this.listenToKeyEvents = function ( domElement ) {

			domElement.addEventListener( 'keydown', onKeyDown );
			this._domElementKeyEvents = domElement;

		};

		this.saveState = function () {

			scope.target0.copy( scope.target );
			scope.position0.copy( scope.object.position );
			scope.zoom0 = scope.object.zoom;

		};

		this.reset = function () {

			scope.target.copy( scope.target0 );
			scope.object.position.copy( scope.position0 );
			scope.object.zoom = scope.zoom0;

			scope.object.updateProjectionMatrix();
			scope.dispatchEvent( _changeEvent );

			scope.update();

			state = STATE.NONE;

		};

		// this method is exposed, but perhaps it would be better if we can make it private...
		this.update = function () {

			const offset = new THREE.Vector3();

			// so camera.up is the orbit axis
			const quat = new THREE.Quaternion().setFromUnitVectors( object.up, new THREE.Vector3( 0, 1, 0 ) );
			const quatInverse = quat.clone().inverse();

			const lastPosition = new THREE.Vector3();
			const lastQuaternion = new THREE.Quaternion();

			const twoPI = 2 * Math.PI;

			return function update() {

				const position = scope.object.position;

				offset.copy( position ).sub( scope.target );

				// rotate offset to "y-axis-is-up" space
				offset.applyQuaternion( quat );

				// angle from z-axis around y-axis
				spherical.setFromVector3( offset );

				if ( scope.autoRotate && state === STATE.NONE ) {

					rotateLeft( getAutoRotationAngle() );

				}

				if ( scope.enableDamping ) {

					spherical.theta += sphericalDelta.theta * scope.dampingFactor;
					spherical.phi += sphericalDelta.phi * scope.dampingFactor;

				} else {

					spherical.theta += sphericalDelta.theta;
					spherical.phi += sphericalDelta.phi;

				}

				// restrict theta to be between desired limits

				let min = scope.minAzimuthAngle;
				let max = scope.maxAzimuthAngle;

				if ( isFinite( min ) && isFinite( max ) ) {

					if ( min < - Math.PI ) min += twoPI; else if ( min > Math.PI ) min -= twoPI;

					if ( max < - Math.PI ) max += twoPI; else if ( max > Math.PI ) max -= twoPI;

					if ( min <= max ) {

						spherical.theta = Math.max( min, Math.min( max, spherical.theta ) );

					} else {

						spherical.theta = ( spherical.theta > ( min + max ) / 2 ) ?
							Math.max( min, spherical.theta ) :
							Math.min( max, spherical.theta );

					}

				}

				// restrict phi to be between desired limits
				spherical.phi = Math.max( scope.minPolarAngle, Math.min( scope.maxPolarAngle, spherical.phi ) );

				spherical.makeSafe();


				spherical.radius *= scale;

				// restrict radius to be between desired limits
				spherical.radius = Math.max( scope.minDistance, Math.min( scope.maxDistance, spherical.radius ) );

				// move target to panned location

				if ( scope.enableDamping === true ) {

					scope.target.addScaledVector( panOffset, scope.dampingFactor );

				} else {

					scope.target.add( panOffset );

				}

				offset.setFromSpherical( spherical );

				// rotate offset back to "camera-up-vector-is-up" space
				offset.applyQuaternion( quatInverse );

				position.copy( scope.target ).add( offset );

				scope.object.lookAt( scope.target );

				if ( scope.enableDamping === true ) {

					sphericalDelta.theta *= ( 1 - scope.dampingFactor );
					sphericalDelta.phi *= ( 1 - scope.dampingFactor );

					panOffset.multiplyScalar( 1 - scope.dampingFactor );

				} else {

					sphericalDelta.set( 0, 0, 0 );

					panOffset.set( 0, 0, 0 );

				}

				scale = 1;

				// update condition is:
				// min(camera displacement, camera rotation in radians)^2 > EPS
				// using small-angle approximation cos(x/2) = 1 - x^2 / 8

				if ( zoomChanged ||
					lastPosition.distanceToSquared( scope.object.position ) > EPS ||
					8 * ( 1 - lastQuaternion.dot( scope.object.quaternion ) ) > EPS ) {

					scope.dispatchEvent( _changeEvent );

					lastPosition.copy( scope.object.position );
					lastQuaternion.copy( scope.object.quaternion );
					zoomChanged = false;

					return true;

				}

				return false;

			};

		}();

		this.dispose = function () {

			scope.domElement.removeEventListener( 'contextmenu', onContextMenu );

			scope.domElement.removeEventListener( 'pointerdown', onPointerDown );
			scope.domElement.removeEventListener( 'wheel', onMouseWheel );

			scope.domElement.removeEventListener( 'touchstart', onTouchStart );
			scope.domElement.removeEventListener( 'touchend', onTouchEnd );
			scope.domElement.removeEventListener( 'touchmove', onTouchMove );

			scope.domElement.ownerDocument.removeEventListener( 'pointermove', onPointerMove );
			scope.domElement.ownerDocument.removeEventListener( 'pointerup', onPointerUp );


			if ( scope._domElementKeyEvents !== null ) {

				scope._domElementKeyEvents.removeEventListener( 'keydown', onKeyDown );

			}

			//scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?

		};

		//
		// internals
		//

		const scope = this;

		const STATE = {
			NONE: - 1,
			ROTATE: 0,
			DOLLY: 1,
			PAN: 2,
			TOUCH_ROTATE: 3,
			TOUCH_PAN: 4,
			TOUCH_DOLLY_PAN: 5,
			TOUCH_DOLLY_ROTATE: 6
		};

		let state = STATE.NONE;

		const EPS = 0.000001;

		// current position in spherical coordinates
		const spherical = new THREE.Spherical();
		const sphericalDelta = new THREE.Spherical();

		let scale = 1;
		const panOffset = new THREE.Vector3();
		let zoomChanged = false;

		const rotateStart = new THREE.Vector2();
		const rotateEnd = new THREE.Vector2();
		const rotateDelta = new THREE.Vector2();

		const panStart = new THREE.Vector2();
		const panEnd = new THREE.Vector2();
		const panDelta = new THREE.Vector2();

		const dollyStart = new THREE.Vector2();
		const dollyEnd = new THREE.Vector2();
		const dollyDelta = new THREE.Vector2();

		function getAutoRotationAngle() {

			return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;

		}

		function getZoomScale() {

			return Math.pow( 0.95, scope.zoomSpeed );

		}

		function rotateLeft( angle ) {

			sphericalDelta.theta -= angle;

		}

		function rotateUp( angle ) {

			sphericalDelta.phi -= angle;

		}

		const panLeft = function () {

			const v = new THREE.Vector3();

			return function panLeft( distance, objectMatrix ) {

				v.setFromMatrixColumn( objectMatrix, 0 ); // get X column of objectMatrix
				v.multiplyScalar( - distance );

				panOffset.add( v );

			};

		}();

		const panUp = function () {

			const v = new THREE.Vector3();

			return function panUp( distance, objectMatrix ) {

				if ( scope.screenSpacePanning === true ) {

					v.setFromMatrixColumn( objectMatrix, 1 );

				} else {

					v.setFromMatrixColumn( objectMatrix, 0 );
					v.crossVectors( scope.object.up, v );

				}

				v.multiplyScalar( distance );

				panOffset.add( v );

			};

		}();

		// deltaX and deltaY are in pixels; right and down are positive
		const pan = function () {

			const offset = new THREE.Vector3();

			return function pan( deltaX, deltaY ) {

				const element = scope.domElement;

				if ( scope.object.isPerspectiveCamera ) {

					// perspective
					const position = scope.object.position;
					offset.copy( position ).sub( scope.target );
					let targetDistance = offset.length();

					// half of the fov is center to top of screen
					targetDistance *= Math.tan( ( scope.object.fov / 2 ) * Math.PI / 180.0 );

					// we use only clientHeight here so aspect ratio does not distort speed
					panLeft( 2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix );
					panUp( 2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix );

				} else if ( scope.object.isOrthographicCamera ) {

					// orthographic
					panLeft( deltaX * ( scope.object.right - scope.object.left ) / scope.object.zoom / element.clientWidth, scope.object.matrix );
					panUp( deltaY * ( scope.object.top - scope.object.bottom ) / scope.object.zoom / element.clientHeight, scope.object.matrix );

				} else {

					// camera neither orthographic nor perspective
					console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.' );
					scope.enablePan = false;

				}

			};

		}();

		function dollyOut( dollyScale ) {

			if ( scope.object.isPerspectiveCamera ) {

				scale /= dollyScale;

			} else if ( scope.object.isOrthographicCamera ) {

				scope.object.zoom = Math.max( scope.minZoom, Math.min( scope.maxZoom, scope.object.zoom * dollyScale ) );
				scope.object.updateProjectionMatrix();
				zoomChanged = true;

			} else {

				console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.' );
				scope.enableZoom = false;

			}

		}

		function dollyIn( dollyScale ) {

			if ( scope.object.isPerspectiveCamera ) {

				scale *= dollyScale;

			} else if ( scope.object.isOrthographicCamera ) {

				scope.object.zoom = Math.max( scope.minZoom, Math.min( scope.maxZoom, scope.object.zoom / dollyScale ) );
				scope.object.updateProjectionMatrix();
				zoomChanged = true;

			} else {

				console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.' );
				scope.enableZoom = false;

			}

		}

		//
		// event callbacks - update the object state
		//

		function handleMouseDownRotate( event ) {

			rotateStart.set( event.clientX, event.clientY );

		}

		function handleMouseDownDolly( event ) {

			dollyStart.set( event.clientX, event.clientY );

		}

		function handleMouseDownPan( event ) {

			panStart.set( event.clientX, event.clientY );

		}

		function handleMouseMoveRotate( event ) {

			rotateEnd.set( event.clientX, event.clientY );

			rotateDelta.subVectors( rotateEnd, rotateStart ).multiplyScalar( scope.rotateSpeed );

			const element = scope.domElement;

			rotateLeft( 2 * Math.PI * rotateDelta.x / element.clientHeight ); // yes, height

			rotateUp( 2 * Math.PI * rotateDelta.y / element.clientHeight );

			rotateStart.copy( rotateEnd );

			scope.update();

		}

		function handleMouseMoveDolly( event ) {

			dollyEnd.set( event.clientX, event.clientY );

			dollyDelta.subVectors( dollyEnd, dollyStart );

			if ( dollyDelta.y > 0 ) {

				dollyOut( getZoomScale() );

			} else if ( dollyDelta.y < 0 ) {

				dollyIn( getZoomScale() );

			}

			dollyStart.copy( dollyEnd );

			scope.update();

		}

		function handleMouseMovePan( event ) {

			panEnd.set( event.clientX, event.clientY );

			panDelta.subVectors( panEnd, panStart ).multiplyScalar( scope.panSpeed );

			pan( panDelta.x, panDelta.y );

			panStart.copy( panEnd );

			scope.update();

		}

		function handleMouseWheel( event ) {

			if ( event.deltaY < 0 ) {

				dollyIn( getZoomScale() );

			} else if ( event.deltaY > 0 ) {

				dollyOut( getZoomScale() );

			}

			scope.update();

		}

		function handleKeyDown( event ) {

			let needsUpdate = false;

			switch ( event.code ) {

				case scope.keys.UP:
					pan( 0, scope.keyPanSpeed );
					needsUpdate = true;
					break;

				case scope.keys.BOTTOM:
					pan( 0, - scope.keyPanSpeed );
					needsUpdate = true;
					break;

				case scope.keys.LEFT:
					pan( scope.keyPanSpeed, 0 );
					needsUpdate = true;
					break;

				case scope.keys.RIGHT:
					pan( - scope.keyPanSpeed, 0 );
					needsUpdate = true;
					break;

			}

			if ( needsUpdate ) {

				// prevent the browser from scrolling on cursor keys
				event.preventDefault();

				scope.update();

			}


		}

		function handleTouchStartRotate( event ) {

			if ( event.touches.length == 1 ) {

				rotateStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

			} else {

				const x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
				const y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

				rotateStart.set( x, y );

			}

		}

		function handleTouchStartPan( event ) {

			if ( event.touches.length == 1 ) {

				panStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

			} else {

				const x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
				const y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

				panStart.set( x, y );

			}

		}

		function handleTouchStartDolly( event ) {

			const dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
			const dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;

			const distance = Math.sqrt( dx * dx + dy * dy );

			dollyStart.set( 0, distance );

		}

		function handleTouchStartDollyPan( event ) {

			if ( scope.enableZoom ) handleTouchStartDolly( event );

			if ( scope.enablePan ) handleTouchStartPan( event );

		}

		function handleTouchStartDollyRotate( event ) {

			if ( scope.enableZoom ) handleTouchStartDolly( event );

			if ( scope.enableRotate ) handleTouchStartRotate( event );

		}

		function handleTouchMoveRotate( event ) {

			if ( event.touches.length == 1 ) {

				rotateEnd.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

			} else {

				const x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
				const y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

				rotateEnd.set( x, y );

			}

			rotateDelta.subVectors( rotateEnd, rotateStart ).multiplyScalar( scope.rotateSpeed );

			const element = scope.domElement;

			rotateLeft( 2 * Math.PI * rotateDelta.x / element.clientHeight ); // yes, height

			rotateUp( 2 * Math.PI * rotateDelta.y / element.clientHeight );

			rotateStart.copy( rotateEnd );

		}

		function handleTouchMovePan( event ) {

			if ( event.touches.length == 1 ) {

				panEnd.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

			} else {

				const x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
				const y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

				panEnd.set( x, y );

			}

			panDelta.subVectors( panEnd, panStart ).multiplyScalar( scope.panSpeed );

			pan( panDelta.x, panDelta.y );

			panStart.copy( panEnd );

		}

		function handleTouchMoveDolly( event ) {

			const dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
			const dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;

			const distance = Math.sqrt( dx * dx + dy * dy );

			dollyEnd.set( 0, distance );

			dollyDelta.set( 0, Math.pow( dollyEnd.y / dollyStart.y, scope.zoomSpeed ) );

			dollyOut( dollyDelta.y );

			dollyStart.copy( dollyEnd );

		}

		function handleTouchMoveDollyPan( event ) {

			if ( scope.enableZoom ) handleTouchMoveDolly( event );

			if ( scope.enablePan ) handleTouchMovePan( event );

		}

		function handleTouchMoveDollyRotate( event ) {

			if ( scope.enableZoom ) handleTouchMoveDolly( event );

			if ( scope.enableRotate ) handleTouchMoveRotate( event );

		}

		//
		// event handlers - FSM: listen for events and reset state
		//

		function onPointerDown( event ) {

			if ( scope.enabled === false ) return;

			switch ( event.pointerType ) {

				case 'mouse':
				case 'pen':
					onMouseDown( event );
					break;

				// TODO touch

			}

		}

		function onPointerMove( event ) {

			if ( scope.enabled === false ) return;

			switch ( event.pointerType ) {

				case 'mouse':
				case 'pen':
					onMouseMove( event );
					break;

				// TODO touch

			}

		}

		function onPointerUp( event ) {

			switch ( event.pointerType ) {

				case 'mouse':
				case 'pen':
					onMouseUp();
					break;

				// TODO touch

			}

		}

		function onMouseDown( event ) {

			// Prevent the browser from scrolling.
			event.preventDefault();

			// Manually set the focus since calling preventDefault above
			// prevents the browser from setting it automatically.

			scope.domElement.focus ? scope.domElement.focus() : window.focus();

			let mouseAction;

			switch ( event.button ) {

				case 0:

					mouseAction = scope.mouseButtons.LEFT;
					break;

				case 1:

					mouseAction = scope.mouseButtons.MIDDLE;
					break;

				case 2:

					mouseAction = scope.mouseButtons.RIGHT;
					break;

				default:

					mouseAction = - 1;

			}

			switch ( mouseAction ) {

				case THREE.MOUSE.DOLLY:

					if ( scope.enableZoom === false ) return;

					handleMouseDownDolly( event );

					state = STATE.DOLLY;

					break;

				case THREE.MOUSE.ROTATE:

					if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

						if ( scope.enablePan === false ) return;

						handleMouseDownPan( event );

						state = STATE.PAN;

					} else {

						if ( scope.enableRotate === false ) return;

						handleMouseDownRotate( event );

						state = STATE.ROTATE;

					}

					break;

				case THREE.MOUSE.PAN:

					if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

						if ( scope.enableRotate === false ) return;

						handleMouseDownRotate( event );

						state = STATE.ROTATE;

					} else {

						if ( scope.enablePan === false ) return;

						handleMouseDownPan( event );

						state = STATE.PAN;

					}

					break;

				default:

					state = STATE.NONE;

			}

			if ( state !== STATE.NONE ) {

				scope.domElement.ownerDocument.addEventListener( 'pointermove', onPointerMove );
				scope.domElement.ownerDocument.addEventListener( 'pointerup', onPointerUp );

				scope.dispatchEvent( _startEvent );

			}

		}

		function onMouseMove( event ) {

			if ( scope.enabled === false ) return;

			event.preventDefault();

			switch ( state ) {

				case STATE.ROTATE:

					if ( scope.enableRotate === false ) return;

					handleMouseMoveRotate( event );

					break;

				case STATE.DOLLY:

					if ( scope.enableZoom === false ) return;

					handleMouseMoveDolly( event );

					break;

				case STATE.PAN:

					if ( scope.enablePan === false ) return;

					handleMouseMovePan( event );

					break;

			}

		}

		function onMouseUp( event ) {

			scope.domElement.ownerDocument.removeEventListener( 'pointermove', onPointerMove );
			scope.domElement.ownerDocument.removeEventListener( 'pointerup', onPointerUp );

			if ( scope.enabled === false ) return;

			scope.dispatchEvent( _endEvent );

			state = STATE.NONE;

		}

		function onMouseWheel( event ) {

			if ( scope.enabled === false || scope.enableZoom === false || ( state !== STATE.NONE && state !== STATE.ROTATE ) ) return;

			event.preventDefault();

			scope.dispatchEvent( _startEvent );

			handleMouseWheel( event );

			scope.dispatchEvent( _endEvent );

		}

		function onKeyDown( event ) {

			if ( scope.enabled === false || scope.enablePan === false ) return;

			handleKeyDown( event );

		}

		function onTouchStart( event ) {

			if ( scope.enabled === false ) return;

			event.preventDefault(); // prevent scrolling

			switch ( event.touches.length ) {

				case 1:

					switch ( scope.touches.ONE ) {

						case THREE.TOUCH.ROTATE:

							if ( scope.enableRotate === false ) return;

							handleTouchStartRotate( event );

							state = STATE.TOUCH_ROTATE;

							break;

						case THREE.TOUCH.PAN:

							if ( scope.enablePan === false ) return;

							handleTouchStartPan( event );

							state = STATE.TOUCH_PAN;

							break;

						default:

							state = STATE.NONE;

					}

					break;

				case 2:

					switch ( scope.touches.TWO ) {

						case THREE.TOUCH.DOLLY_PAN:

							if ( scope.enableZoom === false && scope.enablePan === false ) return;

							handleTouchStartDollyPan( event );

							state = STATE.TOUCH_DOLLY_PAN;

							break;

						case THREE.TOUCH.DOLLY_ROTATE:

							if ( scope.enableZoom === false && scope.enableRotate === false ) return;

							handleTouchStartDollyRotate( event );

							state = STATE.TOUCH_DOLLY_ROTATE;

							break;

						default:

							state = STATE.NONE;

					}

					break;

				default:

					state = STATE.NONE;

			}

			if ( state !== STATE.NONE ) {

				scope.dispatchEvent( _startEvent );

			}

		}

		function onTouchMove( event ) {

			if ( scope.enabled === false ) return;

			event.preventDefault(); // prevent scrolling

			switch ( state ) {

				case STATE.TOUCH_ROTATE:

					if ( scope.enableRotate === false ) return;

					handleTouchMoveRotate( event );

					scope.update();

					break;

				case STATE.TOUCH_PAN:

					if ( scope.enablePan === false ) return;

					handleTouchMovePan( event );

					scope.update();

					break;

				case STATE.TOUCH_DOLLY_PAN:

					if ( scope.enableZoom === false && scope.enablePan === false ) return;

					handleTouchMoveDollyPan( event );

					scope.update();

					break;

				case STATE.TOUCH_DOLLY_ROTATE:

					if ( scope.enableZoom === false && scope.enableRotate === false ) return;

					handleTouchMoveDollyRotate( event );

					scope.update();

					break;

				default:

					state = STATE.NONE;

			}

		}

		function onTouchEnd( event ) {

			if ( scope.enabled === false ) return;

			scope.dispatchEvent( _endEvent );

			state = STATE.NONE;

		}

		function onContextMenu( event ) {

			if ( scope.enabled === false ) return;

			event.preventDefault();

		}

		//

		scope.domElement.addEventListener( 'contextmenu', onContextMenu );

		scope.domElement.addEventListener( 'pointerdown', onPointerDown );
		scope.domElement.addEventListener( 'wheel', onMouseWheel, { passive: false } );

		scope.domElement.addEventListener( 'touchstart', onTouchStart, { passive: false } );
		scope.domElement.addEventListener( 'touchend', onTouchEnd );
		scope.domElement.addEventListener( 'touchmove', onTouchMove, { passive: false } );

		// force an update at start

		this.update();

	}

}


// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move

class MapControls extends OrbitControls {

	constructor( object, domElement ) {

		super( object, domElement );

		this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up

		this.mouseButtons.LEFT = THREE.MOUSE.PAN;
		this.mouseButtons.RIGHT = THREE.MOUSE.ROTATE;

		this.touches.ONE = THREE.TOUCH.PAN;
		this.touches.TWO = THREE.TOUCH.DOLLY_ROTATE;

	}

}

class CustomBasicMaterial extends THREE.ShaderMaterial
{
    constructor(params)
    {
        params.uniforms = THREE.UniformsUtils.merge([params.uniforms,
            THREE.ShaderLib.basic.uniforms,
            { defaultIndirectDiffuse: { value: new THREE.Vector3( 1, 1,1 ) }}
        ]);

        super();
        this.uniforms = params.uniforms;
        this.defines = params.defines;
        this.setValues(params);

        this._morphTargets = false;
        this._morphNormals = false;
        this._useInstancing = false;

        this.isMeshBasicMaterial = true;
    }

    get color()
    {
        return this.uniforms.diffuse.value;
    }

    fromBasicMaterial(source)
    {
        THREE.MeshBasicMaterial.prototype.copy.call(this, source);

        this.color.copy(source.color);

        this.map = source.map;

        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;

        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;

        this.specularMap = source.specularMap;

        this.alphaMap = source.alphaMap;

        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;

        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;

        this.skinning = source.skinning;
        this.morphTargets = source.morphTargets;

        this.extensions.shaderTextureLOD = true;
    }

    set color(value)
    {
        this.uniforms.diffuse.value.set(value);
    }

    get opacity()
    {
        return this.uniforms.opacity.value;
    }

    set opacity(value)
    {
        // set in material constructor when uniforms aren't assigned yet
        if (this.uniforms) this.uniforms.opacity.value = value;
    }

    get map()
    {
        return this.uniforms.map.value;
    }

    set map(value)
    {
        this.needsUpdate = !!this.uniforms.map.value !== !!value;
        this.uniforms.map.value = value;
    }

    get lightMap()
    {
        return this.uniforms.lightMap.value;
    }

    set lightMap(value)
    {
        this.needsUpdate = !!this.uniforms.lightMap.value !== !!value;
        this.uniforms.lightMap.value = value;
    }

    get lightMapIntensity()
    {
        return this.uniforms.lightMapIntensity.value;
    }

    set lightMapIntensity(value)
    {
        this.uniforms.lightMapIntensity.value = value;
    }

    get aoMap()
    {
        return this.uniforms.aoMap.value;
    }

    set aoMap(value)
    {
        this.needsUpdate = !!this.uniforms.aoMap.value !== !!value;
        this.uniforms.aoMap.value = value;
    }

    get aoMapIntensity()
    {
        return this.uniforms.aoMapIntensity.value;
    }

    set aoMapIntensity(value)
    {
        this.uniforms.aoMapIntensity.value = value;
    }

    get alphaMap()
    {
        return this.uniforms.alphaMap.value;
    }

    set alphaMap(value)
    {
        this.needsUpdate = !!this.uniforms.alphaMap.value !== !!value;
        this.uniforms.alphaMap.value = value;
    }

    get envMap()
    {
        return this.uniforms.envMap.value;
    }

    set envMap(value)
    {
        this.needsUpdate = !!this.uniforms.envMap.value !== !!value;
        this.uniforms.envMap.value = value;

        if (value) {
            if (Array.isArray(value.image)) {
                const width = value.image[0].naturalWidth;
                const height = value.image[0].naturalHeight;
                this.uniforms.maxMipLevel.value = Math.log2(Math.max(width, height));
            } else {
                const width = value.image.width;
                const height = value.image.height;
                this.uniforms.maxMipLevel.value = Math.log2(Math.max(width, height));
            }
        }
    }

    get envMapIntensity()
    {
        return this.uniforms.envMapIntensity.value;
    }

    set envMapIntensity(value)
    {
        this.uniforms.envMapIntensity.value = value;
    }

    get refractionRatio()
    {
        return this.uniforms.refractionRatio.value;
    }

    set refractionRatio(value)
    {
        this.uniforms.refractionRatio.value = value;
    }

    get skinning()
    {
        return this._skinning;
    }

    set skinning(value)
    {
        if (this._skinning !== value) this.needsUpdate = true;
        this._skinning = value;
    }

    get morphTargets()
    {
        return this._morphTargets;
    }

    set morphTargets(value)
    {
        if (this._morphTargets !== value) this.needsUpdate = true;
        this._morphTargets = value;
    }

    get morphNormals()
    {
        return this._morphNormals
    }

    set morphNormals(value)
    {
        if (this._morphNormals !== value) this.needsUpdate = true;
        this._morphNormals = value;
    }
}

var vertexShader$2 = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n\n#ifdef USE_TEXTURE_LIGHT\nvarying vec4 vWorldPos;\nvarying vec4 vLocalPos;\nvarying vec3 vWorldNormal;\nvarying vec3 vWorldViewDir;\nvarying vec2 vDiffuseUV;\n\nuniform mat4 toTexLightSpace;\n#endif\n\nvoid main() {\n\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\n\t#endif\n\n   \t#include <begin_vertex>\n   \t#include <morphtarget_vertex>\n   \t#include <skinning_vertex>\n\n    vec4 mvPosition = vec4( transformed, 1.0 );\n\n    #ifdef USE_INSTANCING\n        mvPosition = instanceMatrix * mvPosition;\n    #endif\n\n    #ifdef USE_TEXTURE_LIGHT\n        vWorldPos = modelMatrix * mvPosition;\n        // the position of the shaded point in light texture space (-.5, .5)\n        vLocalPos = toTexLightSpace * vWorldPos;\n        vWorldNormal = mat3(modelMatrix) * normal;\n\n        // seems the cameraPosition is incorrect in VR, so we calculate the inverse?\n        vec3 vrEyePosition = -viewMatrix[3].xyz * mat3(viewMatrix);\n        vWorldViewDir = vrEyePosition - vWorldPos.xyz;\n    #endif\n\n    mvPosition = modelViewMatrix * mvPosition;\n    gl_Position = projectionMatrix * mvPosition;\n\n    #include <logdepthbuf_vertex>\n    #include <clipping_planes_vertex>\n    #include <worldpos_vertex>\n    #include <envmap_vertex>\n    #include <fog_vertex>\n\n}\n";

var fragmentShader$2 = "uniform vec3 diffuse;\nuniform float opacity;\nuniform vec3 defaultIndirectDiffuse;\n\n#ifndef FLAT_SHADED\n\n\tvarying vec3 vNormal;\n\n#endif\n\n\n#ifdef USE_TEXTURE_LIGHT\nvarying vec4 vWorldPos;\nvarying vec4 vLocalPos;   // from surface to screen\nvarying vec3 vWorldViewDir;     // from eye to surface\nvarying vec3 vWorldNormal;\nvarying vec2 vDiffuseUV;\n\n// just contains an average\nuniform sampler2D texLightDiffuseTexture;\nuniform sampler2D texLightSpecularTexture;\nuniform vec3 texLightNormal;\nuniform vec2 texLightSize;\nuniform vec2 texLightTexSize;\nuniform float texLightRadius;\nuniform float texLightIntensity;\nuniform vec3 texLightPosition;\nuniform mat4 toTexLightSpace;\nuniform float texLightNumMips;\nuniform float roughness;\nuniform mat4 fromTexLightSpace;\n#endif\n\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\n#include <roughnessmap_pars_fragment>\n\n\n// from http://www.java-gaming.org/index.php?topic=35123.0\nvec4 cubic(float v){\n    vec4 n = vec4(1.0, 2.0, 3.0, 4.0) - v;\n    vec4 s = n * n * n;\n    float x = s.x;\n    float y = s.y - 4.0 * s.x;\n    float z = s.z - 4.0 * s.y + 6.0 * s.x;\n    float w = 6.0 - x - y - z;\n    return vec4(x, y, z, w) * (1.0/6.0);\n}\n\n// https://stackoverflow.com/questions/13501081/efficient-bicubic-filtering-code-in-glsl\nvec4 textureBicubic(sampler2D sampler, vec2 texCoords, float lod, vec2 texSize)\n{\n    texSize /= pow(2.0, lod);\n\n    vec2 invTexSize = 1.0 / texSize;\n    vec2 uvPixels = texCoords * texSize - 0.5;\n    vec2 fxy = fract(uvPixels);\n    uvPixels -= fxy;\n\n    vec4 xcubic = cubic(fxy.x);\n    vec4 ycubic = cubic(fxy.y);\n\n    vec4 c = uvPixels.xxyy + vec2(-0.5, +1.5).xyxy;\n\n    vec4 s = vec4(xcubic.xz + xcubic.yw, ycubic.xz + ycubic.yw);\n    vec4 offset = c + vec4(xcubic.yw, ycubic.yw) / s;\n\n    offset *= invTexSize.xxyy;\n\n    #ifdef GL_EXT_shader_texture_lod\n        vec4 sample0 = texture2DLodEXT(sampler, offset.xz, lod);\n        vec4 sample1 = texture2DLodEXT(sampler, offset.yz, lod);\n        vec4 sample2 = texture2DLodEXT(sampler, offset.xw, lod);\n        vec4 sample3 = texture2DLodEXT(sampler, offset.yw, lod);\n    #else\n        vec4 sample0 = textureLod(sampler, offset.xz, lod);\n        vec4 sample1 = textureLod(sampler, offset.yz, lod);\n        vec4 sample2 = textureLod(sampler, offset.xw, lod);\n        vec4 sample3 = textureLod(sampler, offset.yw, lod);\n    #endif\n\n    float sx = s.x / (s.x + s.y);\n    float sy = s.z / (s.z + s.w);\n    return mix(\n        mix(sample3, sample2, sx),\n        mix(sample1, sample0, sx)\n    , sy);\n}\n\nvec4 textureBicubicLod(sampler2D sampler, vec2 texCoords, float lod, vec2 texSize)\n{\n    float lod0 = floor(lod);\n    float lod1 = lod0 + 1.0;\n\n    return mix(\n        textureBicubic(sampler, texCoords, lod0, texSize),\n        textureBicubic(sampler, texCoords, lod1, texSize),\n        fract(lod)\n    );\n}\n\nvoid main() {\n\n\t#include <clipping_planes_fragment>\n\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\n    ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\n    // accumulation (baked indirect lighting only)\n    #ifdef USE_LIGHTMAP\n\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\n    #else\n\n    reflectedLight.indirectDiffuse += defaultIndirectDiffuse;\n\n    #endif\n\n    // modulation\n    #include <aomap_fragment>\n\n    vec3 specular = vec3(0.0);\n\n    #ifdef USE_TEXTURE_LIGHT\n        vec3 L = normalize(texLightPosition - vWorldPos.xyz);\n        vec3 N = normalize(vWorldNormal);\n        float nDotL = max(dot(L, N), 0.0);\n\n        // the point on the light closest to the given point\n        vec4 screenPos = vec4(clamp(vLocalPos.xy, -.5, .5), 0.0, 1.0);\n        vec2 diffuseUV = screenPos.xy + .5;\n        screenPos = fromTexLightSpace * screenPos;\n\n        // DIFFUSE: approximate as advanced point light\n        float dist = distance(screenPos.xyz, vWorldPos.xyz);\n        // TODO: Figure out mip-level (if LOD supported) to sample diffuse texture\n        vec3 color = texture2D(texLightDiffuseTexture, diffuseUV).rgb;\n        float radiusDamp = clamp(1.0 - dist / texLightRadius, 0.0, 1.0);\n        float intensity = radiusDamp / (dist * dist) * texLightIntensity;\n\n        float sDotL = max(-dot(L, texLightNormal), 0.0);\n        reflectedLight.indirectDiffuse += color * nDotL * sDotL * intensity;\n\n\n        // SPECULAR: intersect with a plane (x3 the size of the specular reflection)\n        vec3 V = normalize(vWorldViewDir);\n        vec3 R = -reflect(V, N);\n\n        // intersect with plane\n        float denom = -dot(texLightNormal.xyz, R);\n        float t = -dot(texLightPosition - vWorldPos.xyz, texLightNormal);\n        // not intersecting, or traveling in opposite direction of the screen\n        if (denom > 0.001 && t > 0.0) {\n            // T is the distance to the plane, so functions to calculate the width of the cone\n            t /= denom;\n\n            vec3 intersection = vWorldPos.xyz + R * t;\n            vec2 uv = (toTexLightSpace * vec4(intersection, 1.0)).xy;\n            uv /= 3.0;\n            uv += .5;\n\n            #include <roughnessmap_fragment>\n            float a = roughnessFactor * roughnessFactor;\n            float cover = min(a * t, 1.0);\n            float f0 = 0.027;\n            float cosAngle = 1.0 - max(-dot(N, V), 0.0);\n            // to the 5th power\n            float power = pow(cosAngle, 5.0);\n            float gloss = 1.0 - cover;\n            float bound = max(gloss * gloss, f0);\n            float fresnel = f0 + (bound - f0) * power;\n\n            float mip = cover * texLightNumMips;\n            #ifdef BICUBIC\n            specular = textureBicubicLod(texLightSpecularTexture, uv, mip, texLightTexSize).rgb;\n            #else\n            specular = texture2D(texLightSpecularTexture, uv, mip).rgb;\n            #endif\n\n            specular *= nDotL * fresnel * radiusDamp * clamp(texLightIntensity, 0.0, 1.0);\n        }\n    #endif\n\n    reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\n    vec3 outgoingLight = reflectedLight.indirectDiffuse + specular;\n\n    #include <envmap_fragment>\n\n    gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\n    #include <premultiplied_alpha_fragment>\n    #include <tonemapping_fragment>\n    #include <colorspace_fragment>\n    #include <fog_fragment>\n}\n";

/**
 * TextureLightBasicMaterial works exactly like MeshBasicMaterial, but allows the assignment of a TextureLight.
 */
class TextureLightBasicMaterial extends CustomBasicMaterial
{
    constructor(textureLight, bicubic = true)
    {
        super({
            vertexShader: vertexShader$2,
            fragmentShader: fragmentShader$2,
            uniforms: {
                texLightDiffuseTexture: { value: null },
                texLightSpecularTexture: { value: null },
                texLightPosition: { value: new THREE.Vector3() },
                texLightNormal: { value: new THREE.Vector3() },
                texLightRadius: { value: 1.0 },
                texLightIntensity: { value: 1.0 },
                texLightSize: { value: new THREE.Vector2() },
                texLightTexSize: { value: new THREE.Vector2() },
                toTexLightSpace: { value: new THREE.Matrix4() },
                fromTexLightSpace: { value: new THREE.Matrix4() },
                texLightNumMips: { value: 0.0 },
                roughnessMap: { value: null },
                roughness: { value: 1 },
            },
            defines: {},
            extensions: { shaderTextureLOD: true }
        });

        this.isMeshBasicTextureLightMaterial = true;
        this._onPropsChanged = this._onPropsChanged.bind(this);
        this.textureLight = textureLight;
        if (bicubic) this.defines.BICUBIC = '';
    }

    get roughnessMap() {
        return this.uniforms.roughnessMap.value;
    }

    set roughnessMap(value) {
        this.needsUpdate = !!this.uniforms.roughnessMap.value !== !!value;
        if (this.needsUpdate) {
            if (this.uniforms.roughnessMap.value) {
                this.defines.USE_ROUGHNESSMAP = '';
            } else {
                delete this.defines.USE_ROUGHNESSMAP;
            }
        }
        this.uniforms.roughnessMap.value = value;
    }

    get roughness()
    {
        return this.uniforms.roughness.value;
    }

    set roughness(value)
    {
        this.uniforms.roughness.value = value;
    }

    get textureLight()
    {
        return this._textureLight;
    }

    set textureLight(value)
    {
        if (this._textureLight === value) return;

        if (!!this._textureLight !== !!value)
            this.needsUpdate = true;

        if (this._textureLight)
            this._textureLight.unregisterChangeListener(this._onPropsChanged);

        this._textureLight = value;
        if (this._textureLight) {
            this.uniforms.defaultIndirectDiffuse.value = this._textureLight.overridingBasicMaterialIndirectDiffuse;
        } else {
            this.uniforms.defaultIndirectDiffuse.value = new THREE.Vector3(1, 1, 1);
        }

        if (this._textureLight) {
            this._textureLight.registerChangeListener(this._onPropsChanged);
            this.defines.USE_TEXTURE_LIGHT = "";
            this.uniforms.texLightDiffuseTexture.value = value.diffuseTexture;
            this.uniforms.texLightSpecularTexture.value = value.specularTexture;
            this.uniforms.texLightNumMips.value = value.specularTextureMipCount;
            this.uniforms.texLightTexSize.value.set(value.specularTextureSize, value.specularTextureSize);
            this._onPropsChanged();
        }
        else
            delete this.defines.USE_TEXTURE_LIGHT;
    }

    dispose()
    {
        super.dispose();
    }

    _onPropsChanged()
    {
        // this will impact the specular light
        const pos =  this.uniforms.texLightPosition.value;
        const normal = this.uniforms.texLightNormal.value;
        pos.setFromMatrixColumn(this._textureLight.matrixWorld, 3);
        normal.setFromMatrixColumn(this._textureLight.matrixWorld, 2).normalize();
        this.uniforms.texLightRadius.value = this._textureLight.radius;
        this.uniforms.texLightIntensity.value = this._textureLight.intensity;
        this.uniforms.texLightSize.value.set(this._textureLight.width, this._textureLight.height);
        const lightMatrix = this._textureLight.lightMatrix;
        this.uniforms.fromTexLightSpace.value = lightMatrix;
        this.uniforms.toTexLightSpace.value.copy(lightMatrix).invert();
    }
}

var vertexShader$1 = "#define STANDARD\n\nvarying vec3 vViewPosition;\n\n#ifndef FLAT_SHADED\n\nvarying vec3 vNormal;\n\n#ifdef USE_TANGENT\n\nvarying vec3 vTangent;\nvarying vec3 vBitangent;\n\n#endif\n\n#endif\n\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n\n#ifdef USE_TEXTURE_LIGHT\nvarying vec4 vWorldPos;\nvarying vec4 vLocalPos;\n\nuniform mat4 toTexLightSpace;\n#endif\n\nvoid main() {\n\n    #include <uv_vertex>\n    #include <color_vertex>\n\n    #include <beginnormal_vertex>\n    #include <morphnormal_vertex>\n    #include <skinbase_vertex>\n    #include <skinnormal_vertex>\n    #include <defaultnormal_vertex>\n\n    #ifndef FLAT_SHADED // Normal computed with derivatives when FLAT_SHADED\n\n    vNormal = normalize( transformedNormal );\n\n    #ifdef USE_TANGENT\n\n    vTangent = normalize( transformedTangent );\n    vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\n    #endif\n\n    #endif\n\n    #include <begin_vertex>\n    #include <morphtarget_vertex>\n    #include <skinning_vertex>\n    #include <displacementmap_vertex>\n\n    vec4 mvPosition = vec4( transformed, 1.0 );\n\n    #ifdef USE_INSTANCING\n    mvPosition = instanceMatrix * mvPosition;\n    #endif\n\n    #ifdef USE_TEXTURE_LIGHT\n    vWorldPos = modelMatrix * mvPosition;\n    // the position of the shaded point in light texture space (-.5, .5)\n    vLocalPos = toTexLightSpace * vWorldPos;\n    #endif\n\n    mvPosition = modelViewMatrix * mvPosition;\n    gl_Position = projectionMatrix * mvPosition;\n\n    #include <logdepthbuf_vertex>\n    #include <clipping_planes_vertex>\n\n    vViewPosition = - mvPosition.xyz;\n\n    vec4 worldPosition = vec4( transformed, 1.0 );\n\n    #ifdef USE_INSTANCING\n\n    worldPosition = instanceMatrix * worldPosition;\n\n    #endif\n\n    worldPosition = modelMatrix * worldPosition;\n\n    #include <shadowmap_vertex>\n    #include <fog_vertex>\n\n}";

var fragmentShader$1 = "#define STANDARD\n\n#ifdef PHYSICAL\n#define REFLECTIVITY\n#define CLEARCOAT\n#define TRANSPARENCY\n#endif\n\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n\n#ifdef TRANSPARENCY\nuniform float transparency;\n#endif\n\n#ifdef REFLECTIVITY\nuniform float reflectivity;\n#endif\n\n#ifdef CLEARCOAT\nuniform float clearcoat;\nuniform float clearcoatRoughness;\n#endif\n\n#ifdef USE_SHEEN\nuniform vec3 sheen;\n#endif\n\nvarying vec3 vViewPosition;\n\n#ifndef FLAT_SHADED\n\nvarying vec3 vNormal;\n\n#ifdef USE_TANGENT\n\nvarying vec3 vTangent;\nvarying vec3 vBitangent;\n\n#endif\n\n#endif\n\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\n\n#ifdef USE_TEXTURE_LIGHT\nvarying vec4 vWorldPos;\nvarying vec4 vLocalPos;\n\n// just contains an average\nuniform sampler2D texLightDiffuseTexture;\nuniform sampler2D texLightSpecularTexture;\nuniform vec3 texLightNormal;\nuniform vec2 texLightSize;\nuniform vec2 texLightTexSize;\nuniform float texLightRadius;\nuniform float texLightIntensity;\nuniform vec3 texLightPosition;\nuniform mat4 toTexLightSpace;\nuniform float texLightNumMips;\nuniform mat4 fromTexLightSpace;\n#endif\n\n\n// from http://www.java-gaming.org/index.php?topic=35123.0\nvec4 cubic(float v){\n    vec4 n = vec4(1.0, 2.0, 3.0, 4.0) - v;\n    vec4 s = n * n * n;\n    float x = s.x;\n    float y = s.y - 4.0 * s.x;\n    float z = s.z - 4.0 * s.y + 6.0 * s.x;\n    float w = 6.0 - x - y - z;\n    return vec4(x, y, z, w) * (1.0/6.0);\n}\n\n// https://stackoverflow.com/questions/13501081/efficient-bicubic-filtering-code-in-glsl\nvec4 textureBicubic(sampler2D sampler, vec2 texCoords, float lod, vec2 texSize)\n{\n    texSize /= pow(2.0, lod);\n\n    vec2 invTexSize = 1.0 / texSize;\n    vec2 uvPixels = texCoords * texSize - 0.5;\n    vec2 fxy = fract(uvPixels);\n    uvPixels -= fxy;\n\n    vec4 xcubic = cubic(fxy.x);\n    vec4 ycubic = cubic(fxy.y);\n\n    vec4 c = uvPixels.xxyy + vec2(-0.5, +1.5).xyxy;\n\n    vec4 s = vec4(xcubic.xz + xcubic.yw, ycubic.xz + ycubic.yw);\n    vec4 offset = c + vec4(xcubic.yw, ycubic.yw) / s;\n\n    offset *= invTexSize.xxyy;\n\n    #ifdef TEXTURE_LOD_EXT\n    vec4 sample0 = texture2DLodEXT(sampler, offset.xz, lod);\n    vec4 sample1 = texture2DLodEXT(sampler, offset.yz, lod);\n    vec4 sample2 = texture2DLodEXT(sampler, offset.xw, lod);\n    vec4 sample3 = texture2DLodEXT(sampler, offset.yw, lod);\n    #else\n    vec4 sample0 = textureLod(sampler, offset.xz, lod);\n    vec4 sample1 = textureLod(sampler, offset.yz, lod);\n    vec4 sample2 = textureLod(sampler, offset.xw, lod);\n    vec4 sample3 = textureLod(sampler, offset.yw, lod);\n    #endif\n\n    float sx = s.x / (s.x + s.y);\n    float sy = s.z / (s.z + s.w);\n    return mix(\n    mix(sample3, sample2, sx),\n    mix(sample1, sample0, sx)\n    , sy);\n}\n\nvec4 textureBicubicLod(sampler2D sampler, vec2 texCoords, float lod, vec2 texSize)\n{\n    float lod0 = floor(lod);\n    float lod1 = lod0 + 1.0;\n\n    return mix(\n    textureBicubic(sampler, texCoords, lod0, texSize),\n    textureBicubic(sampler, texCoords, lod1, texSize),\n    fract(lod)\n    );\n}\n\nvoid main() {\n\n    #include <clipping_planes_fragment>\n\n    vec4 diffuseColor = vec4( diffuse, opacity );\n    ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n    vec3 totalEmissiveRadiance = emissive;\n\n    #include <logdepthbuf_fragment>\n    #include <map_fragment>\n    #include <color_fragment>\n    #include <alphamap_fragment>\n    #include <alphatest_fragment>\n    #include <roughnessmap_fragment>\n    #include <metalnessmap_fragment>\n    #include <normal_fragment_begin>\n    #include <normal_fragment_maps>\n    #include <clearcoat_normal_fragment_begin>\n    #include <clearcoat_normal_fragment_maps>\n    #include <emissivemap_fragment>\n\n    // accumulation\n    #include <lights_physical_fragment>\n    #include <lights_fragment_begin>\n    #include <lights_fragment_maps>\n    #include <lights_fragment_end>\n\n    #ifdef USE_TEXTURE_LIGHT\n    vec3 L = normalize(texLightPosition - vWorldPos.xyz);\n    vec3 N = inverseTransformDirection(geometryNormal, viewMatrix);\n    float nDotL = max(dot(L, N), 0.0);\n\n    // the point on the light closest to the given point\n    vec4 screenPos = vec4(clamp(vLocalPos.xy, -.5, .5), 0.0, 1.0);\n    vec2 diffuseUV = screenPos.xy + .5;\n    screenPos = fromTexLightSpace * screenPos;\n\n    // DIFFUSE: approximate as advanced point light\n    float dist = distance(screenPos.xyz, vWorldPos.xyz);\n\n    // TODO: Figure out mip-level (if LOD supported) to sample diffuse texture?\n    vec3 color = texture2D(texLightDiffuseTexture, diffuseUV).rgb;\n    float radiusDamp = clamp(1.0 - dist / texLightRadius, 0.0, 1.0);\n    float intensity = radiusDamp / (dist * dist) * texLightIntensity;\n\n    float sDotL = max(-dot(L, texLightNormal), 0.0);\n    reflectedLight.directDiffuse += color * nDotL * sDotL * intensity * diffuseColor.rgb;\n\n    // SPECULAR: intersect with a plane (x3 the size of the specular reflection)\n    vec3 V = normalize(cameraPosition - vWorldPos.xyz);\n    vec3 R = -reflect(V, N);\n\n    // intersect with plane\n    float denom = -dot(texLightNormal.xyz, R);\n    float t = -dot(texLightPosition - vWorldPos.xyz, texLightNormal);\n    // not intersecting, or traveling in opposite direction of the screen\n    if (denom > 0.001 && t > 0.0) {\n        // T is the distance to the plane, so functions to calculate the width of the cone\n        t /= denom;\n\n        vec3 intersection = vWorldPos.xyz + R * t;\n        vec2 uv = (toTexLightSpace * vec4(intersection, 1.0)).xy;\n        uv /= 3.0;\n        uv += .5;\n\n        float a = roughnessFactor * roughnessFactor;\n        float cover = min(a * t, 1.0);\n        float f0 = 0.027;\n        float cosAngle = 1.0 - max(-dot(N, V), 0.0);\n        // to the 5th power\n        float power = pow(cosAngle, 5.0);\n        float gloss = 1.0 - cover;\n        float bound = max(gloss * gloss, f0);\n        float fresnel = f0 + (bound - f0) * power;\n\n        float mip = cover * texLightNumMips;\n        #ifdef BICUBIC\n        vec3 specular = textureBicubicLod(texLightSpecularTexture, uv, mip, texLightTexSize).rgb;\n        #else\n        vec3 specular = texture2D(texLightSpecularTexture, uv, mip).rgb;\n        #endif\n\n        specular *= nDotL * fresnel * radiusDamp * clamp(texLightIntensity, 0.0, 1.0);\n\n        reflectedLight.directSpecular += specular;\n    }\n    #endif\n\n    // modulation\n    #include <aomap_fragment>\n\n    vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\n    // this is a stub for the transparency model\n    #ifdef TRANSPARENCY\n    diffuseColor.a *= saturate( 1. - transparency + linearToRelativeLuminance( reflectedLight.directSpecular + reflectedLight.indirectSpecular ) );\n    #endif\n\n\n    gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\n    #include <tonemapping_fragment>\n    #include <colorspace_fragment>\n    #include <fog_fragment>\n    #include <premultiplied_alpha_fragment>\n    #include <dithering_fragment>\n\n}\n";

class CustomStandardMaterial extends THREE.ShaderMaterial {
    constructor(params) {
        params.uniforms = THREE.UniformsUtils.merge([params.uniforms, THREE.ShaderLib.standard.uniforms]);
        params.lights = true;

        super();
        this.uniforms = params.uniforms;
        this.defines = params.defines;
        this.setValues(params);

        this.normalMapType = THREE.TangentSpaceNormalMap;
        this.opacity = 1;
        this.normalScale = new THREE.Vector2(1, 1);

        this._morphTargets = false;
        this._morphNormals = false;
        this._useInstancing = false;

        this.isMeshStandardMaterial = true;
    }

    fromStandardMaterial(material) {
        const initDefines = { ... this.defines };
        THREE.MeshStandardMaterial.prototype.copy.call(this, material);
        this.defines = { ...this.defines, ...initDefines };
    }

    get color() {
        return this.uniforms.diffuse.value
    }

    set color(value) {
        this.uniforms.diffuse.value.set(value);
    }

    get metalness() {
        return this.uniforms.metalness.value
    }

    set metalness(value) {
        this.uniforms.metalness.value = value;
    }

    get roughness() {
        return this.uniforms.roughness.value
    }

    set roughness(value) {
        this.uniforms.roughness.value = value;
    }

    get opacity() {
        return this.uniforms.opacity.value
    }

    set opacity(value) {
        // set in material constructor when uniforms aren't assigned yet
        if (this.uniforms) this.uniforms.opacity.value = value;
    }

    get map() {
        return this.uniforms.map.value
    }

    set map(value) {
        this.needsUpdate = !!this.uniforms.map.value !== !!value;
        this.uniforms.map.value = value;
    }

    get lightMap() {
        return this.uniforms.lightMap.value
    }

    set lightMap(value) {
        this.needsUpdate = !!this.uniforms.lightMap.value !== !!value;
        this.uniforms.lightMap.value = value;
    }

    get lightMapIntensity() {
        return this.uniforms.lightMapIntensity.value
    }

    set lightMapIntensity(value) {
        this.uniforms.lightMapIntensity.value = value;
    }

    get aoMap() {
        return this.uniforms.aoMap.value
    }

    set aoMap(value) {
        this.needsUpdate = !!this.uniforms.aoMap.value !== !!value;
        this.uniforms.aoMap.value = value;
    }

    get aoMapIntensity() {
        return this.uniforms.aoMapIntensity.value
    }

    set aoMapIntensity(value) {
        this.uniforms.aoMapIntensity.value = value;
    }

    get emissive() {
        return this.uniforms.emissive.value
    }

    set emissive(value) {
        this.uniforms.emissive.value.set(value);
    }

    get emissiveMap() {
        return this.uniforms.emissiveMap.value
    }

    set emissiveMap(value) {
        this.needsUpdate = !!this.uniforms.emissiveMap.value !== !!value;
        this.uniforms.emissiveMap.value = value;
    }

    get bumpMap() {
        return this.uniforms.bumpMap.value
    }

    set bumpMap(value) {
        this.needsUpdate = !!this.uniforms.bumpMap.value !== !!value;
        this.uniforms.bumpMap.value = value;
    }

    get bumpScale() {
        return this.uniforms.bumpScale.value
    }

    set bumpScale(value) {
        this.uniforms.bumpScale.value = value;
    }

    get normalMap() {
        return this.uniforms.normalMap.value
    }

    set normalMap(value) {
        this.needsUpdate = !!this.uniforms.normalMap.value !== !!value;
        this.uniforms.normalMap.value = value;
    }

    get normalMapType() {
        return this._normalMapType
    }

    set normalMapType(value) {
        this.needsUpdate = this._normalMapType !== value;
        this._normalMapType = value;
    }

    get normalScale() {
        return this.uniforms.normalScale.value
    }

    set normalScale(value) {
        this.uniforms.normalScale.value = value;
    }

    get displacementMap() {
        return this.uniforms.displacementMap.value
    }

    set displacementMap(value) {
        this.needsUpdate = !!this.uniforms.displacementMap.value !== !!value;
        this.uniforms.displacementMap.value = value;
    }

    get displacementScale() {
        return this.uniforms.displacementScale.value
    }

    set displacementScale(value) {
        this.uniforms.displacementScale.value = value;
    }

    get displacementBias() {
        return this.uniforms.displacementBias.value
    }

    set displacementBias(value) {
        this.uniforms.displacementBias.value = value;
    }

    get roughnessMap() {
        return this.uniforms.roughnessMap.value
    }

    set roughnessMap(value) {
        this.needsUpdate = !!this.uniforms.roughnessMap.value !== !!value;
        this.uniforms.roughnessMap.value = value;
    }

    get metalnessMap() {
        return this.uniforms.metalnessMap.value
    }

    set metalnessMap(value) {
        this.needsUpdate = !!this.uniforms.metalnessMap.value !== !!value;
        this.uniforms.metalnessMap.value = value;
    }

    get alphaMap() {
        return this.uniforms.alphaMap.value
    }

    set alphaMap(value) {
        this.needsUpdate = !!this.uniforms.alphaMap.value !== !!value;
        this.uniforms.alphaMap.value = value;
    }

    get envMap() {
        return this.uniforms.envMap.value
    }

    set envMap(value) {
        this.needsUpdate = !!this.uniforms.envMap.value !== !!value;
        this.uniforms.envMap.value = value;

        if (value) {
            if (Array.isArray(value.image)) {
                const width = value.image[0].naturalWidth;
                const height = value.image[0].naturalHeight;
                this.uniforms.maxMipLevel.value = Math.log2(Math.max(width, height));
            } else {
                const width = value.image.width;
                const height = value.image.height;
                this.uniforms.maxMipLevel.value = Math.log2(Math.max(width, height));
            }
        }
    }

    get envMapIntensity() {
        return this.uniforms.envMapIntensity.value
    }

    set envMapIntensity(value) {
        this.uniforms.envMapIntensity.value = value;
    }

    get refractionRatio() {
        return this.uniforms.refractionRatio.value
    }

    set refractionRatio(value) {
        this.uniforms.refractionRatio.value = value;
    }

    get skinning() {
        return this._skinning
    }

    set skinning(value) {
        if (this._skinning !== value) this.needsUpdate = true;
        this._skinning = value;
    }

    get morphTargets() {
        return this._morphTargets
    }

    set morphTargets(value) {
        if (this._morphTargets !== value) this.needsUpdate = true;

        this._morphTargets = value;
    }

    get morphNormals() {
        return this._morphNormals
    }

    set morphNormals(value) {
        if (this._morphNormals !== value) this.needsUpdate = true;

        this._morphNormals = value;
    }
}

/**
 * TextureLightStandardMaterial works exactly like MeshStandardMaterial, but allows the assignment of a TextureLight.
 */
class TextureLightStandardMaterial extends CustomStandardMaterial
{
    constructor(textureLight, bicubic = true)
    {
        super({
            vertexShader: vertexShader$1,
            fragmentShader: fragmentShader$1,
            uniforms: {
                texLightDiffuseTexture: { value: null },
                texLightSpecularTexture: { value: null },
                texLightPosition: { value: new THREE.Vector3() },
                texLightNormal: { value: new THREE.Vector3() },
                texLightRadius: { value: 1.0 },
                texLightIntensity: { value: 1.0 },
                texLightSize: { value: new THREE.Vector2() },
                texLightTexSize: { value: new THREE.Vector2() },
                toTexLightSpace: { value: new THREE.Matrix4() },
                fromTexLightSpace: { value: new THREE.Matrix4() },
                texLightNumMips: { value: 0.0 },
            },
            defines: {},
            extensions: { shaderTextureLOD: true, derivatives: true }
        });

        if (bicubic) this.defines.BICUBIC = '';
        this._onPropsChanged = this._onPropsChanged.bind(this);
        this.textureLight = textureLight;
    }

    get textureLight()
    {
        return this._textureLight;
    }

    set textureLight(value)
    {
        if (this._textureLight === value) return;

        if (!!this._textureLight !== !!value)
            this.needsUpdate = true;

        if (this._textureLight)
            this._textureLight.unregisterChangeListener(this._onPropsChanged);

        this._textureLight = value;

        if (this._textureLight) {
            this._textureLight.registerChangeListener(this._onPropsChanged);
            this.defines.USE_TEXTURE_LIGHT = "";
            this.uniforms.texLightDiffuseTexture.value = value.diffuseTexture;
            this.uniforms.texLightSpecularTexture.value = value.specularTexture;
            this.uniforms.texLightNumMips.value = value.specularTextureMipCount;
            this.uniforms.texLightTexSize.value.set(value.specularTextureSize, value.specularTextureSize);
            this._onPropsChanged();
        }
        else
            delete this.defines.USE_TEXTURE_LIGHT;
    }

    dispose()
    {
        super.dispose();
        //@TODO should I remove this because onSizeChanged does not seems to be used
    }

    _onPropsChanged()
    {
        this.needsUpdate = true;

        // this will impact the specular light
        const pos =  this.uniforms.texLightPosition.value;
        const normal = this.uniforms.texLightNormal.value;
        pos.setFromMatrixColumn(this._textureLight.matrixWorld, 3);
        normal.setFromMatrixColumn(this._textureLight.matrixWorld, 2).normalize();
        this.uniforms.texLightRadius.value = this._textureLight.radius;
        this.uniforms.texLightIntensity.value = this._textureLight.intensity;
        this.uniforms.texLightSize.value.set(this._textureLight.width, this._textureLight.height);
        const lightMatrix = this._textureLight.lightMatrix;
        this.uniforms.fromTexLightSpace.value = lightMatrix;
        this.uniforms.toTexLightSpace.value.copy(lightMatrix).invert();

        if (this._textureLight) {
            // this._textureLight.onPropsChanged.bind(this._onPropsChanged, this);
            this.defines.USE_TEXTURE_LIGHT = "";
            this.uniforms.texLightDiffuseTexture.value = this._textureLight.diffuseTexture;
            this.uniforms.texLightSpecularTexture.value = this._textureLight.specularTexture;
            this.uniforms.texLightNumMips.value = this._textureLight.specularTextureMipCount;
            this.uniforms.texLightTexSize.value.set(this._textureLight.specularTextureSize, this._textureLight.specularTextureSize);
            // this._onPropsChanged();
        }
        else
            delete this.defines.USE_TEXTURE_LIGHT;

    }
}

class EventDispatcher {
	constructor() {
		this.topicsSubscriptions = {};
	}

	notifySubscribers(topic, data) {
		if (!topic || typeof topic !== "string") {
			return;
		}

		if (!this.topicsSubscriptions.hasOwnProperty(topic)) {
			return;
		}

		this.topicsSubscriptions[topic].forEach(callback => {
			try {
				callback(data);
			} catch (e) {
				console.error(`Error calling callback for topic ${topic}`, e);
			}
		});
	}

	subscribeToTopic(topic, callback) {
		if (!topic || typeof topic !== "string") {
			console.error(`Could not subscribe. Invalid topic ${topic}`);
			return;
		}

		if (!this.topicsSubscriptions.hasOwnProperty(topic)) {
			this.topicsSubscriptions[topic] = [];
		}

		this.unsubscribeFromTopic(topic, callback);

		this.topicsSubscriptions[topic].push(callback);
	}

	unsubscribeFromTopic(topic, callback) {
		if (!topic || typeof topic !== "string") {
			console.error(`Could not unsubscribe. Invalid topic ${topic}`);
			return;
		}

		if (!this.topicsSubscriptions.hasOwnProperty(topic)) {
			console.error(`Could not unsubscribe. Topic ${topic} not found`);
			return;
		}

		const topicSubscriptions = this.topicsSubscriptions[topic];
		const index = topicSubscriptions.indexOf(callback);
		if (index >= 0) {
			topicSubscriptions.splice(index, 1);
		}
	}
}

const EVENTS = {
	TEXTURE_LIGHT_CHANGED: "texture_light_changed",
};

class TextureLightEvents extends EventDispatcher {
	constructor() {
		super();
	}

	get EVENTS() {
		return EVENTS;
	}

	textureLightChanged() {
		this.notifySubscribers(EVENTS.TEXTURE_LIGHT_CHANGED, {});
	}
}

// export default new TextureLightEvents();

let mesh;
let planeGeom$1;
let copyCamera;
let copyMaterial;
let vp = new THREE.Vector4();
new THREE.Vector4();

/**
 * Full-screen textured quad shader
 */

const CopyShader = {

    uniforms: {

        'tDiffuse': { value: null },
        'opacity': { value: 1.0 }

    },

    vertexShader: [

        'varying vec2 vUv;',

        'void main() {',

        '	vUv = uv;',
        '	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',

        '}'

    ].join( '\n' ),

    fragmentShader: [

        'uniform float opacity;',

        'uniform sampler2D tDiffuse;',

        'varying vec2 vUv;',

        'void main() {',

        '	vec4 texel = texture2D( tDiffuse, vUv );',
        '	gl_FragColor = opacity * texel;',

        '}'

    ].join( '\n' )

};


function getCopyCamera() {
    if (!copyCamera) {
        copyCamera = new THREE.OrthographicCamera(-1, 1, 1, -1);
        copyCamera.position.set(0, 0, 1);
    }

    return copyCamera;
}
function renderCopy(renderer, source, target, clear, customMaterial, keepRT, viewport) {
    if (!copyMaterial) {
        copyMaterial = new THREE.ShaderMaterial(CopyShader);
        planeGeom$1 = new THREE.PlaneBufferGeometry(2, 2);
        mesh = new THREE.Mesh(planeGeom$1, copyMaterial);
    }

    const copyCamera = getCopyCamera();

    const oldRT = renderer.getRenderTarget();
    const material = customMaterial || copyMaterial;
    material.uniforms.tDiffuse.value = source;
    mesh.material = material;

    const autoClear = renderer.autoClear;

    renderer.autoClear = clear === undefined ? true : clear;
    renderer.setRenderTarget(target);

    viewport = viewport || target.viewport;
    renderer.getViewport(vp);
    renderer.setViewport(viewport);

    const xr = renderer.xr.enabled;
    renderer.xr.enabled = false;
    renderer.render(mesh, copyCamera);
    if (!keepRT) renderer.setRenderTarget(oldRT);
    renderer.autoClear = autoClear;

    renderer.xr.enabled = xr;
    renderer.setViewport(vp);
}

var vertexShader = "varying highp vec2 vUv;\n\nvoid main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";

var fragmentShader = "uniform sampler2D tDiffuse;\nuniform float lightCurve;\n\nvarying highp vec2 vUv;\n\nfloat linearToRelativeLuminance( const in vec3 color ) {\n    vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n    return dot( weights, color.rgb );\n}\n\nvoid main() {\n\n    gl_FragColor = texture2D(tDiffuse, vUv);\n\n    #ifdef DECODE\n    // to linear\n    gl_FragColor.rgb *= gl_FragColor.rgb;\n//    float lum = linearToRelativeLuminance(gl_FragColor.rgb);\n//    float tgtLum = pow(lum, lightCurve);\n//    gl_FragColor.rgb *= tgtLum / max(lum, 0.001);\n    #endif\n}\n";

const planeGeom = new THREE.PlaneGeometry(1,  1);

/**
 * TextureLight provides a 3D object in the scene that functions as a textured rectangular light.
 * To be used with TextureLight<***>Material
 */
class TextureLight extends THREE.Group
{
    /**
     * Creates a new TextureLight object.
     * @param renderer The main WebGLRenderer.
     * @param texture The texture to use for the light.
     * @param specularTextureSize An optional texture size for the specular reflection map. Must be a power of two.
     * Smaller values are more performant.
     */
    constructor(renderer, texture, specularTextureSize)
    {
        super();
        this.eventDispatcher = new TextureLightEvents();
        // this.onPropsChanged = new Signal();
        this._version = -1;
        this._radius = 100.0;
        this._intensity = 4.0;
        this._renderer = renderer;
        this._overridingBasicMaterialIndirectDiffuse = new THREE.Vector3(1, 1, 1);

        this._mesh = new THREE.Mesh(planeGeom, new THREE.MeshBasicMaterial(
            {
                map: texture,
                visible: false,
                transparent: true
                // color: new Color(this._intensity, this._intensity, this._intensity)
            }
        ));
        this.add(this._mesh);
        this.texture = texture;

        this._mipTexture = new THREE.WebGLRenderTarget(64, 64, {
            depthBuffer: false,
            generateMipmaps: true,
            minFilter: THREE.LinearMipmapLinearFilter,
        });

        this._specularTextureSize = specularTextureSize || 1024;

        this._diffuseRT = new THREE.WebGLRenderTarget(2, 2, {depthBuffer: false, stencilBuffer: false});
        this._specularRT = new THREE.WebGLRenderTarget(this._specularTextureSize, this._specularTextureSize, {
            depthBuffer: false, stencilBuffer: false,
            generateMipmaps: true,
            minFilter: THREE.LinearMipMapNearestFilter,
            magFilter: THREE.LinearFilter,
            wrapS: THREE.ClampToEdgeWrapping,
            wrapT: THREE.ClampToEdgeWrapping,
        });

        // centered with the video being 1/3
        const dim = Math.floor(this._specularTextureSize / 3 / renderer.getPixelRatio());
        this._specViewport = new THREE.Vector4(dim, dim, dim, dim);

        this._avgMaterialEnc = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,
            uniforms: {
                tDiffuse: {value: null},
                // lightCurve: { value: 1 },
                defines: {},
            },
        });
        this._avgMaterialEnc.defines.ENCODE = '';

        this._avgMaterialDec = this._avgMaterialEnc.clone();
        this._avgMaterialDec.defines.DECODE = '';
    }

    set overridingBasicMaterialIndirectDiffuse(value) {
        this._overridingBasicMaterialIndirectDiffuse.copy(value);
    }

    get overridingBasicMaterialIndirectDiffuse() {
        return this._overridingBasicMaterialIndirectDiffuse;
    }

    /**
     * The texture size for the specular reflection map. Must be a power of two.
     */
    get specularTextureSize()
    {
        return this._specularTextureSize;
    }

    get specularTextureMipCount()
    {
        return 1.0 + Math.floor(Math.log2(this._specularTextureSize));
    }

    /**
     * This is used by the materials. It transforms from local light space (coordinates range from -.5, .5 within the
     * light surface).
     */
    get lightMatrix()
    {
        return this._mesh.matrixWorld;
    }

    /**
     * The intensity of the light. Keep in mind that changing width/height also affects the amount of light in the scene.
     */
    get intensity()
    {
        return this._intensity;
    }

    set intensity(value)
    {
        if (this._intensity === value) return;
        this._intensity = value;

        // this.color.set(this._intensity, this._intensity, this._intensity);

        this.dispatchEvent();
    }

    /**
     * The texture used for the VideoLight.
     */
    get texture()
    {
        return this._texture;
    }

    set texture(value)
    {
        this._version = -1;
        this._texture = value;

        this._mesh.scale.set(1, 1, 1);
        this.dispatchEvent();
    }

    /**
     * The width of the video screen. Texture aspect ratio will be maintained.
     */
    get width()
    {
        return this.scale.x;
    }

    set width(value)
    {
        if (this.scale.x === value) return;
        this.scale.x = value;
        this.dispatchEvent();
    }

    dispatchEvent() {
        this.eventDispatcher.textureLightChanged();
    }

    registerChangeListener(fct) {
        this.eventDispatcher.subscribeToTopic(this.eventDispatcher.EVENTS.TEXTURE_LIGHT_CHANGED, fct);
    }

    unregisterChangeListener(fct) {
        this.eventDispatcher.unsubscribeFromTopic(this.eventDispatcher.EVENTS.TEXTURE_LIGHT_CHANGED, fct);
    }

    /**
     * The height of the video screen. Texture aspect ratio will be maintained.
     */
    get height()
    {
        return this.scale.y;
    }

    set height(value)
    {
        if (this.scale.y === value) return;
        this.scale.y = value;
        this.dispatchEvent();
    }

    /**
     * The diffuse texture, containing the average colour values for the screen, used by materials.
     */
    get diffuseTexture()
    {
        return this._diffuseRT.texture;
    }

    get specularTexture()
    {
        return this._specularRT.texture;
    }

    /**
     * The maximum reach of the light. Next to the physical light fall-off, the radius can be used to further reduce the
     * maximum range of the light. This is not a physically correct parameter, but can help with performance (no need to assign
     * video lights to materials that are out of range).
     */
    get radius()
    {
        return this._radius;
    }

    set radius(value)
    {
        if (value === this._radius) return;
        this._radius = value;
        this.dispatchEvent();
    }

    /**
     * This needs to be called every frame in order to keep the texture info updated.
     */
    update()
    {
        if ( !this._texture || this._texture.version === this._version ) return;

        this._version = this._texture.version;

        renderCopy(this._renderer, this._texture, this._mipTexture, true, this._avgMaterialEnc);
        renderCopy(this._renderer, this._mipTexture.texture, this._diffuseRT, true, this._avgMaterialDec);

        renderCopy(this._renderer, this._texture, this._specularRT, true, this._avgMaterialEnc, false, this._specViewport);
    }

    /**
     * Override for three.js
     */
    updateMatrixWorld(force)
    {
        super.updateMatrixWorld(force);

        this.dispatchEvent();
    }
}

class MaterialUtils
{
    static setMaterial(object, material)
    {
        object.traverse(obj => {
            if (obj.isMesh && obj.material) {
                obj.material = material;
            }
        });
    }

    /**
     * Replaces all materials in an object by a new material of a given type, propagating the default material parameters.
     */
    static replaceMaterial(object, factoryFunc)
    {
        const map = {};
        object.traverse(obj => {
            // if obj.material's uuid is already
            if (obj.isMesh && obj.material) {
                const srcMat = obj.material;
                let dstMat;

                // keep sharing materials when possible
                if (map.hasOwnProperty(srcMat.uuid)) {
                    dstMat = map[srcMat.uuid];
                } else {
                    dstMat = factoryFunc(srcMat);
                    map[srcMat.uuid] = dstMat;
                }

                obj.material = dstMat;
            }
        });
    }
}

const TEXTURE_LIGHT_SYSTEM_NAME = "texture-light-system";

function registerTextureLightSystem() {
  if (AFRAME.systems[TEXTURE_LIGHT_SYSTEM_NAME]) return;

  AFRAME.registerSystem(TEXTURE_LIGHT_SYSTEM_NAME, {
    init: function() {
      this._texturedLight = new TextureLight(this.el.sceneEl.renderer, null);
    },

    getTextureLight() {
      return this._texturedLight;
    }
  });
}

function registerTextureLightControllerComponent() {
  if (AFRAME.components["texture-light-controller"]) return;

  AFRAME.registerComponent("texture-light-controller", {
    schema: {
      intensity: { type: "number", default: 1 },
      radius: { type: "number", default: 100 },
      width: { type: "number" },
      height: { type: "number" }
    },
    init() {

    },
    update() {
      this._texturedLight = this.getTexturedLight();
      if (!isNaN(this.data.radius)) {
        this._texturedLight.radius = this.data.radius;
      }
      if (!isNaN(this.data.width)) {
        this._texturedLight.width = this.data.width;
      }
      if (!isNaN(this.data.height)) {
        this._texturedLight.height = this.data.height;
      }
      if (!isNaN(this.data.intensity)) {
        this._texturedLight.intensity = this.data.intensity;
      }
    },
    getTexturedLight() {
      return this.el.sceneEl.systems[TEXTURE_LIGHT_SYSTEM_NAME].getTextureLight();
    },
  });

}

function registerTextureLightMaterialComponent() {
	if (AFRAME.components["texture-light-material"]) return;
	AFRAME.registerComponent("texture-light-material", {
		schema: {
			alphaTest: {default: 0.0, min: 0.0, max: 1.0},
			depthTest: {default: true},
			depthWrite: {default: true},
			flatShading: {default: false},
			textureLight: { default: null},
			roughness: { default: 1.0 },
			roughnessMap: {type: "map", default: null},
			npot: {default: false},
			offset: {type: 'vec2', default: {x: 0, y: 0}},
			opacity: {default: 1.0, min: 0.0, max: 1.0},
			repeat: {type: 'vec2', default: {x: 1, y: 1}},
			shader: {default: 'standard', oneOf: ["flat", "basic"], schemaChange: true},
			side: {default: 'front', oneOf: ['front', 'back', 'double']},
			transparent: {default: false},
			visible: {default: true},
			blending: {default: 'normal', oneOf: ['none', 'normal', 'additive', 'subtractive', 'multiply']},
			dithering: {default: true}
		},

		init: function () {
			this.material = null;
			this.system = AFRAME.scenes[0].systems["material"];
		},

		/**
		 * Update or create material.
		 *
		 * @param {object|null} oldData
		 */
		update: function (oldData) {
			var data = this.data;
			if (!this.shader || data.shader !== oldData.shader) {
				this.updateShader(data.shader);
			}
			this.shader.update(this.data);
			this.updateMaterial(oldData);
		},

		updateSchema: function (data) {
			var currentShader;
			var newShader;
			var schema;
			var shader;

			newShader = data && data.shader;
			currentShader = this.oldData && this.oldData.shader;
			shader = newShader || currentShader;
			schema = AFRAME.shaders[shader] && AFRAME.shaders[shader].schema;

			if (!schema) { error('Unknown shader schema ' + shader); }
			if (currentShader && newShader === currentShader) { return; }
			this.extendSchema(schema);
			this.updateBehavior();
		},

		updateBehavior: function () {
			var key;
			var sceneEl = this.el.sceneEl;
			var schema = this.schema;
			var self = this;
			var tickProperties;

			function tickTime (time, delta) {
				var key;
				for (key in tickProperties) {
					tickProperties[key] = time;
				}
				self.shader.update(tickProperties);
			}

			this.tick = undefined;

			tickProperties = {};
			for (key in schema) {
				if (schema[key].type === 'time') {
					this.tick = tickTime;
					tickProperties[key] = true;
				}
			}

			if (!sceneEl) { return; }
			if (this.tick) {
				sceneEl.addBehavior(this);
			} else {
				sceneEl.removeBehavior(this);
			}
		},

		updateShader: function (shaderName) {
			var data = this.data;
			var Shader = AFRAME.shaders[shaderName] && AFRAME.shaders[shaderName].Shader;
			var shaderInstance;

			if (!Shader) { throw new Error('Unknown shader ' + shaderName); }

			// Get material from A-Frame shader.
			shaderInstance = this.shader = new Shader();
			shaderInstance.el = this.el;
			shaderInstance.init(data);

			let nwMaterial = shaderInstance.material;
			const initialMaterial = shaderInstance.material;
			if (initialMaterial.isMeshStandardMaterial) {
				const nwTexturedMaterial = new TextureLightStandardMaterial(this.data.textureLight);
				nwTexturedMaterial.fromStandardMaterial(nwMaterial);
				nwMaterial = nwTexturedMaterial;
			} else if (initialMaterial.isMeshBasicMaterial) {
				const nwTexturedMaterial = new TextureLightBasicMaterial(this.data.textureLight);
				nwTexturedMaterial.fromBasicMaterial(nwMaterial);
				nwMaterial = nwTexturedMaterial;
			}
			this.setMaterial(nwMaterial);
			this.updateSchema(data);
		},

		/**
		 * Set and update base material properties.
		 * Set `needsUpdate` when needed.
		 */
		updateMaterial: function (oldData) {
			var data = this.data;
			var material = this.material;
			var oldDataHasKeys;

			if (oldData.textureLight !== this.data.textureLight) {
				this.material.textureLight = this.data.textureLight;
			}

			// Base material properties.
			material.alphaTest = data.alphaTest;
			material.depthTest = data.depthTest !== false;
			material.depthWrite = data.depthWrite !== false;
			material.opacity = data.opacity;
			material.flatShading = data.flatShading;
			material.side = parseSide(data.side);
			material.transparent = data.transparent !== false || data.opacity < 1.0;
			material.visible = data.visible;
			material.blending = parseBlending(data.blending);
			material.dithering = data.dithering;

			material.map = data.src;
			//New material properties
			material.roughness = data.roughness;
			material.roughnessMap = data.roughnessMap;

			// Check if material needs update.
			for (oldDataHasKeys in oldData) { break; }
			if (oldDataHasKeys &&
				(oldData.alphaTest !== data.alphaTest ||
					oldData.side !== data.side ||
					oldData.vertexColors !== data.vertexColors)) {
				material.needsUpdate = true;
			}
		},

		/**
		 * Remove material on remove (callback).
		 * Dispose of it from memory and unsubscribe from scene updates.
		 */
		remove: function () {
			var defaultMaterial = new THREE.MeshBasicMaterial();
			var material = this.material;
			var object3D = this.el.getObject3D('mesh');
			if (object3D) { object3D.material = defaultMaterial; }
			disposeMaterial(material, this.system);
		},

		/**
		 * (Re)create new material. Has side-effects of setting `this.material` and updating
		 * material registration in scene.
		 *
		 * @param {object} data - Material component data.
		 * @param {object} type - Material type to create.
		 * @returns {object} Material.
		 */
		setMaterial: function (material) {
			var el = this.el;
			var mesh;
			var system = this.system;

			if (this.material) { disposeMaterial(this.material, system); }

			this.material = material;
			system.registerMaterial(material);

			// Set on mesh. If mesh does not exist, wait for it.
			mesh = el.getObject3D('mesh');
			if (mesh) {
				mesh.material = material;
			} else {
				el.addEventListener('object3dset', function waitForMesh (evt) {
					if (evt.detail.type !== 'mesh' || evt.target !== el) { return; }
					el.getObject3D('mesh').material = material;
					el.removeEventListener('object3dset', waitForMesh);
				});
			}
		}
	});

}


/**
 * Return a three.js constant determining which material face sides to render
 * based on the side parameter (passed as a component property).
 *
 * @param {string} [side=front] - `front`, `back`, or `double`.
 * @returns {number} THREE.FrontSide, THREE.BackSide, or THREE.DoubleSide.
 */
function parseSide (side) {
	switch (side) {
		case 'back': {
			return THREE.BackSide;
		}
		case 'double': {
			return THREE.DoubleSide;
		}
		default: {
			// Including case `front`.
			return THREE.FrontSide;
		}
	}
}

/**
 * Return a three.js constant determining blending
 *
 * @param {string} [blending=normal]
 * - `none`, additive`, `subtractive`,`multiply` or `normal`.
 * @returns {number}
 */
function parseBlending (blending) {
	switch (blending) {
		case 'none': {
			return THREE.NoBlending;
		}
		case 'additive': {
			return THREE.AdditiveBlending;
		}
		case 'subtractive': {
			return THREE.SubtractiveBlending;
		}
		case 'multiply': {
			return THREE.MultiplyBlending;
		}
		default: {
			return THREE.NormalBlending;
		}
	}
}

/**
 * Dispose of material from memory and unsubscribe material from scene updates like fog.
 */
function disposeMaterial (material, system) {
	material.dispose();
	system.unregisterMaterial(material);
}

export { FirstPersonControls, FlyControls, MapControls, MaterialUtils, OrbitControls, TEXTURE_LIGHT_SYSTEM_NAME, TextureLight, TextureLightBasicMaterial, TextureLightStandardMaterial, registerTextureLightControllerComponent, registerTextureLightMaterialComponent, registerTextureLightSystem };
